import { CSSPropertiesOmitted, defaults } from '../types';

export const setSyles = ({
  t,
  l,
  w,
  h,
  z,
  sx,
}: {
  t: number;
  l: number;
  w: number;
  h: number;
  z?: number;
  sx?: CSSPropertiesOmitted;
}) => {
  const sxData = sx ? { ...sx } : {};

  return {
    width: `${w}px`,
    height: `${h}px`,
    top: `${t}px`,
    left: `${l}px`,
    zIndex: z ?? defaults.zIndex,
    ...sxData,
  };
};
